import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import ProductImage from './ProductImage';
import StockBadge from './StockBadge';
import { cur } from '@/lib/currency';

export default function ProductGridCard({ product, imageSrc, onQuickAdd }) {
  const navigate = useNavigate();
  const categ = product.categ_id;

  return (
    <div
      className="bg-card border border-border rounded-2xl overflow-hidden flex flex-col cursor-pointer hover:shadow-md hover:border-primary/30 transition-all active:scale-[0.98]"
      onClick={() => navigate(`/products/${product.id}`)}
    >
      {/* Image */}
      <div className="relative">
        <ProductImage src={imageSrc} categ={categ} size="card" />
        {/* Stock badge overlay - top right */}
        <div className="absolute top-2 left-2">
          <StockBadge qty={product.qty_available} />
        </div>
      </div>

      {/* Info */}
      <div className="p-3 flex flex-col gap-2 flex-1">
        {product.default_code && (
          <p className="text-xs text-muted-foreground font-mono leading-none">{product.default_code}</p>
        )}
        <p className="text-sm font-semibold text-foreground leading-snug line-clamp-3">
          {product.name}
        </p>
        {categ && (
          <p className="text-xs text-muted-foreground line-clamp-1">
            {Array.isArray(categ) ? categ[1] : categ}
          </p>
        )}

        <div className="mt-auto flex items-center justify-between gap-1 pt-1">
          <p className="font-bold text-primary text-base leading-none">
            {Number(product.list_price || 0).toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} <span className="text-xs font-normal">{cur()}</span>
          </p>
          <button
            onClick={e => { e.stopPropagation(); onQuickAdd?.(product); }}
            className="w-8 h-8 bg-primary rounded-xl flex items-center justify-center hover:bg-primary/90 transition-colors flex-shrink-0"
          >
            <ShoppingCart className="w-3.5 h-3.5 text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}